import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AdminService from '../../services/admin.services';
import logger from '../../utils/logger';
import styles from './permissionGroups.module.css';

const PermissionGroups = () => {
  const [permissionGroups, setPermissionGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPermissionGroups = async () => {
      try {
        setIsLoading(true);
        const response = await AdminService.getPermissionGroups();
        if (response.data && response.data.groups) {
          setPermissionGroups(response.data.groups);
        } else {
          setError('Invalid response format from server');
        }
      } catch (error) {
        logger.error('Error fetching permission groups:', error);
        setError('Failed to fetch permission groups');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPermissionGroups();
  }, []);

  if (isLoading) {
    return (
      <Paper elevation={3} className={styles.permissionGroupContainer}>
        <Typography variant="body1" className={styles.loading}>
          Loading permission groups...
        </Typography>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper elevation={3} className={styles.permissionGroupContainer}>
        <Alert severity="error" className={styles.error}>
          {error}
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} className={styles.permissionGroupContainer}>
      <Box sx={{ p: 2 }}>
        <Alert severity="info" className={styles.infoMessage}>
          Developer access required to modify or add permission groups in the backend.
        </Alert>

        <Typography variant="h6" sx={{ mb: 3, color: '#333', fontWeight: 500 }}>
          Available Permission Groups
        </Typography>

        {permissionGroups.map((group) => (
          <Accordion key={group.name} className={styles.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: '#1D9F9F' }} />}
              aria-controls={`${group.name}-content`}
              id={`${group.name}-header`}
              className={styles.accordionHeader}
              classes={{
                expanded: styles.expanded
              }}
            >
              <Typography className={styles.groupName}>
                {group.displayName || group.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <pre className={styles.jsonContent}>
                {JSON.stringify(group, null, 2)}
              </pre>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Paper>
  );
};

export default PermissionGroups;